export default {
    TITLE: 'Profil',
};
